
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {FilialResponse, ICashbox} from "@providers/filial/_models";

type Props = {
  column: ColumnInstance<ICashbox>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
